import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CartState } from '@store/reducers';

export const selectCartState = createFeatureSelector<CartState>('cart');

export const selectCartList = createSelector(
  selectCartState, 
  (state: CartState) => state.items
);

export const selectCart = createSelector(
  selectCartState,
  (state: CartState) => state.cart
);

export const selectCartForm = createSelector(
  selectCartState,
  (state: CartState) => state.cartForm
);

export const selectCategoryError = createSelector(
  selectCartState,
  (state: CartState) => state.error
);

export const selectCartTotals = createSelector(
  selectCartState,
  (state: CartState) => state.cartTotals
);

